module.exports = __webpack_public_path__ + "img/logo.823b6883.jpg";